import { getConfig } from '@constants';

export const isSafariBrowser = (): boolean => !!(!IS_SSR ? getConfig().userAgent : navigator?.userAgent).match(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari/);
